import { Dropdown } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import type { Dispatch, SetStateAction } from 'react';
import vconst from 'utils/helpers/structs/vconst';
import EToolTip from 'components/others/EToolTip';
import { isSameIdSet } from 'utils/helpers/list/isSameIdSet';
import SolarIcon from 'components/icons/SolarIcon';

const defaultProductFilterStatus = [vconst.prodActive];

interface ProductFilterStatusProps {
    filterStatus: number[];
    setFilterStatus: Dispatch<SetStateAction<number[]>>;
}

const ProductFilterStatus = ({ filterStatus, setFilterStatus }: ProductFilterStatusProps) => {
    const { t } = useTranslation(['Products']);
    const filterActive = !isSameIdSet(filterStatus, defaultProductFilterStatus);

    const menu = (
        <Dropdown.Menu popperConfig={{ strategy: 'fixed' }} renderOnMount>
            <Dropdown.Item
                onClick={(e) => {
                    e.currentTarget.blur();
                    setFilterStatus([vconst.prodActive, vconst.prodArchive]);
                }}
            >
                <div className="d-flex align-items-center">
                    <input
                        type="radio"
                        checked={
                            filterStatus?.includes(vconst.prodActive) &&
                            filterStatus?.includes(vconst.prodArchive)
                        }
                        onChange={() => null}
                        className="form-check-input me-2"
                    />
                    {t('prodArchive.all')}
                </div>
            </Dropdown.Item>

            <Dropdown.Item
                onClick={(e) => {
                    e.currentTarget.blur();
                    setFilterStatus([1]);
                }}
            >
                <div className="d-flex align-items-center">
                    <input
                        type="radio"
                        checked={
                            filterStatus?.includes(vconst.prodActive) &&
                            !filterStatus?.includes(vconst.prodArchive)
                        }
                        onChange={() => null}
                        className="form-check-input me-2"
                    />
                    {t('prodArchive.active')}
                </div>
            </Dropdown.Item>

            <Dropdown.Item
                className="text-danger"
                onClick={(e) => {
                    e.currentTarget.blur();
                    setFilterStatus([0]);
                }}
            >
                <div className="d-flex align-items-center">
                    <input
                        type="radio"
                        checked={
                            !filterStatus?.includes(vconst.prodActive) &&
                            filterStatus?.includes(vconst.prodArchive)
                        }
                        onChange={() => null}
                        className="form-check-input me-2"
                    />
                    {t('prodArchive.archive')}
                </div>
            </Dropdown.Item>
        </Dropdown.Menu>
    );

    return (
        <EToolTip title={t('toolArchiveFilter')}>
            <span className="d-inline-block">
                <Dropdown align="end">
                    <Dropdown.Toggle
                        className="fs-14 px-2 ms-1"
                        size="sm"
                        variant={filterActive ? 'danger' : 'primary'}
                        id="dropdown-products-filter"
                    >
                        <SolarIcon name="funnel" className="fs-14 p-0" />
                    </Dropdown.Toggle>

                    {typeof document !== 'undefined' ? createPortal(menu, document.body) : menu}
                </Dropdown>
            </span>
        </EToolTip>
    );
};

export default ProductFilterStatus;
